import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from './router.js';
import ENV from '@/environment';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    enterClassName: 'animated slideInRight',
    leaveClassName: 'animated slideOutLeft',
    enterClassNameVoile: 'animated',
    leaveClassNameVoile: 'animated fadeOut',
    loader: false,
    isLogoHidden: false,
    isHeaderMenuOpen: false,
    isFooterMenuOpen: false,
    openFilter: false,
    isHamburgerMobileActive: false,
    city: {},
    department: {},
    filterCities: [],
    filterDepartments: [],
    apiUrl: ENV.APP_API_HOST || 'https://webwalks.ru/w/delimobil-career/api/api.php',
    pageLoaded: false,
    vacanciesLoaded: false,
    vacancyLoaded: false,
    pagesLoaded: {},
    pages: {}
  },
  mutations: {
    changeTransitionEffects(state, params) {
      if (params.isMobile) {
        state.enterClassName = 'animated fadeIn';
        state.leaveClassName = 'animated';
      } else {
        state.enterClassName = 'animated slideInRight';
        state.leaveClassName = 'animated slideOutLeft';
      }
    },
    changeVoileTransitionEffects(state) {
      state.enterClassNameVoile = 'animated fadeIn';
      state.leaveClassNameVoile = 'animated fadeOut';
    },
    loaderON(state) {
      state.loader = true;
    },
    loaderOFF(state) {
      state.loader = false;
    },
    toggleLogo(state) {
      state.isLogoHidden = !state.isLogoHidden;
    },
    toggleHeaderMenu: function(state) {
      state.isHeaderMenuOpen = !state.isHeaderMenuOpen;
    },
    toggleFooterMenu: function(state) {
      state.isFooterMenuOpen = !state.isFooterMenuOpen;
    },
    toggleHamburgerMobile: function(state) {
      state.isHamburgerMobileActive = !state.isHamburgerMobileActive;
    },
    toggleFilter(state) {
      state.openFilter = !state.openFilter;
    },
    hideHeaderMenu: function(state) {
      state.isHeaderMenuOpen = false;
    },
    hideFooterMenu: function(state) {
      state.isFooterMenuOpen = false;
    },
    changeCity(state, params) {
      for (let i in state.filterCities) {
        if (state.filterCities[i].id === params.val.id) {
          state.city = state.filterCities[i];
          state.filterDepartments = state.filterCities[i].filterDepartments;
          state.department = state.filterCities[i].filterDepartments[0];
          break;
        }
      }
    },
    changeDepartment(state, params) {
      for (let i in state.filterCities) {
        for (let j in state.filterCities[i].filterDepartments) {
          if (state.filterCities[i].filterDepartments[j].id === params.val.id) {
            state.city = state.filterCities[i];
            state.filterDepartments = state.filterCities[i].filterDepartments;
            state.department = state.filterCities[i].filterDepartments[j];
            break;
          }
        }
      }
    },
    pageLoaded: function(state, params) {
      state.pageLoaded = true;

      state.pagesLoaded[params.page] = true;
    },
    vacanciesLoaded: function(state) {
      state.vacanciesLoaded = true;
    },
    vacancyLoaded: function(state) {
      state.vacancyLoaded = true;
    }
  },
  getters: {
    vacancies: state => {
      return state.department && state.department.vacancies ? state.department.vacancies : [];
    },
    images: state => {
      return state.department && state.department.images ? state.department.images : [];
    },
    imagesCount: state => {
      return state.department && state.department.images ? state.department.images.length : 0;
    },
    imagesList: state => {
      let images = [];

      for (let i in state.filterCities) {
        for (let j in state.filterCities[i].filterDepartments) {
          for (let ii in state.filterCities[i].filterDepartments[j].images) {
            for (let jj in state.filterCities[i].filterDepartments[j].images[ii]) {
              images.push(state.filterCities[i].filterDepartments[j].images[ii][jj]);
            }
          }
        }
      }

      return images;
    },
    video: state => {
      return state.department && state.department.video ? state.department.video : '';
    }
  },
  actions: {
    async loadData({ commit, state }, params) {
      let response = await axios.get(state.apiUrl, {
        params: {
          action: 'loadData',
          page: params.page
        }
      });

      let data = response.data.data;

      Vue.set(state.pages, params.page, data);

      commit('pageLoaded', params);
    },
    async loadVacancies({ commit, state }, params) {
      let response = await axios.get(state.apiUrl, {
        params: {
          action: 'loadVacancies'
        }
      });

      if (!response.data.success) {
        router.push('Home');
      }

      let data = response.data.data;

      Vue.set(state, 'filterCities', data.filterCities);
      Vue.set(state, 'city', data.filterCities[0]);
      Vue.set(state, 'filterDepartments', data.filterCities[0].filterDepartments);
      Vue.set(state, 'department', data.filterCities[0].filterDepartments[0]);

      commit('vacanciesLoaded');
    },
    async loadVacancy({ commit, state }, params) {
      let response = await axios.get(state.apiUrl, {
        params: {
          action: 'loadVacancy',
          id: params.id
        }
      });

      if (!response.data.success) {
        router.push('Home');
      }

      let data = response.data.data;

      Vue.set(state, 'vacancy', data);

      commit('vacancyLoaded', params);
    }
  }
});

export default store;
